import { forwardRef, useState } from "react";

import CustomPickerModal from "./CustomPickerModal";
import { CustomGradientPicker, GRADIENT_DEFAULTS } from "@theorgchartdev/storybook";
import {
  AccountSettingsSectionRoutes,
  getAccountSettingsTestPrefix
} from "@/providers/NavigationProvider";

const themeTestPrefix = getAccountSettingsTestPrefix(AccountSettingsSectionRoutes.Theme);

const CustomGradientPickerModal = forwardRef((props, ref) => {
  const [value, setValue] = useState(GRADIENT_DEFAULTS);

  const handleSave = () => {
    props.onSave(value);
    props.onClose();
  };

  return (
    <CustomPickerModal
      ref={ref}
      show={props.show}
      onClose={props.onClose}
      onSave={handleSave}
      cancelTestId={`${themeTestPrefix}-gradient-color-cancel-btn`}
      saveTestId={`${themeTestPrefix}-gradient-color-save-btn`}
    >
      <CustomGradientPicker
        value={value}
        onChange={setValue}
        customColors={props.customColors}
        onCustomAdd={props.onCustomAdd}
      />
    </CustomPickerModal>
  );
});

export default CustomGradientPickerModal;
